import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

const DisplaySettingsIcon = forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon ref={ref} viewBox="0 0 13 14" {...props}>
      <path
        d="M0 7.25C0 7.38807 0.111929 7.5 0.25 7.5H2.75C2.88807 7.5 3 7.38807 3 7.25V6.75C3 6.61193 2.88807 6.5 2.75 6.5H0.25C0.111929 6.5 0 6.61193 0 6.75V7.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 7.5C0.111929 7.5 0 7.38807 0 7.25V6.75C0 6.61193 0.111929 6.5 0.25 6.5H2.75C2.88807 6.5 3 6.61193 3 6.75V7.25C3 7.38807 2.88807 7.5 2.75 7.5H0.25Z"
        fill="white"
      />
      <path
        d="M6 7.25C6 7.38807 6.11193 7.5 6.25 7.5H12.75C12.8881 7.5 13 7.38807 13 7.25V6.75C13 6.61193 12.8881 6.5 12.75 6.5H6.25C6.11193 6.5 6 6.61193 6 6.75V7.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 7.5C6.11193 7.5 6 7.38807 6 7.25V6.75C6 6.61193 6.11193 6.5 6.25 6.5H12.75C12.8881 6.5 13 6.61193 13 6.75V7.25C13 7.38807 12.8881 7.5 12.75 7.5H6.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6C3.94772 6 3.5 6.44772 3.5 7C3.5 7.55228 3.94772 8 4.5 8C5.05228 8 5.5 7.55228 5.5 7C5.5 6.44772 5.05228 6 4.5 6ZM2.5 7C2.5 5.89543 3.39543 5 4.5 5C5.60457 5 6.5 5.89543 6.5 7C6.5 8.10457 5.60457 9 4.5 9C3.39543 9 2.5 8.10457 2.5 7Z"
        fill="white"
      />
      <path
        d="M0 12.25C0 12.3881 0.111929 12.5 0.25 12.5H6.75C6.88807 12.5 7 12.3881 7 12.25V11.75C7 11.6119 6.88807 11.5 6.75 11.5H0.25C0.111929 11.5 0 11.6119 0 11.75V12.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 12.5C0.111929 12.5 0 12.3881 0 12.25V11.75C0 11.6119 0.111929 11.5 0.25 11.5H6.75C6.88807 11.5 7 11.6119 7 11.75V12.25C7 12.3881 6.88807 12.5 6.75 12.5H0.25Z"
        fill="white"
      />
      <path
        d="M10 12.25C10 12.3881 10.1119 12.5 10.25 12.5H12.75C12.8881 12.5 13 12.3881 13 12.25V11.75C13 11.6119 12.8881 11.5 12.75 11.5H10.25C10.1119 11.5 10 11.6119 10 11.75V12.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 12.5C10.1119 12.5 10 12.3881 10 12.25V11.75C10 11.6119 10.1119 11.5 10.25 11.5H12.75C12.8881 11.5 13 11.6119 13 11.75V12.25C13 12.3881 12.8881 12.5 12.75 12.5H10.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 11C7.94772 11 7.5 11.4477 7.5 12C7.5 12.5523 7.94772 13 8.5 13C9.05228 13 9.5 12.5523 9.5 12C9.5 11.4477 9.05228 11 8.5 11ZM6.5 12C6.5 10.8954 7.39543 10 8.5 10C9.60457 10 10.5 10.8954 10.5 12C10.5 13.1046 9.60457 14 8.5 14C7.39543 14 6.5 13.1046 6.5 12Z"
        fill="white"
      />
      <path
        d="M0 2.25C0 2.38807 0.111929 2.5 0.25 2.5H6.75C6.88807 2.5 7 2.38807 7 2.25V1.75C7 1.61193 6.88807 1.5 6.75 1.5H0.25C0.111929 1.5 0 1.61193 0 1.75V2.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 2.5C0.111929 2.5 0 2.38807 0 2.25V1.75C0 1.61193 0.111929 1.5 0.25 1.5H6.75C6.88807 1.5 7 1.61193 7 1.75V2.25C7 2.38807 6.88807 2.5 6.75 2.5H0.25Z"
        fill="white"
      />
      <path
        d="M10 2.25C10 2.38807 10.1119 2.5 10.25 2.5H12.75C12.8881 2.5 13 2.38807 13 2.25V1.75C13 1.61193 12.8881 1.5 12.75 1.5H10.25C10.1119 1.5 10 1.61193 10 1.75V2.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 2.5C10.1119 2.5 10 2.38807 10 2.25V1.75C10 1.61193 10.1119 1.5 10.25 1.5H12.75C12.8881 1.5 13 1.61193 13 1.75V2.25C13 2.38807 12.8881 2.5 12.75 2.5H10.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1C7.94772 1 7.5 1.44772 7.5 2C7.5 2.55228 7.94772 3 8.5 3C9.05228 3 9.5 2.55228 9.5 2C9.5 1.44772 9.05228 1 8.5 1ZM6.5 2C6.5 0.895431 7.39543 0 8.5 0C9.60457 0 10.5 0.895431 10.5 2C10.5 3.10457 9.60457 4 8.5 4C7.39543 4 6.5 3.10457 6.5 2Z"
        fill="white"
      />
    </SvgIcon>
  );
});

export default DisplaySettingsIcon;
